var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVtwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867",
    transform: "translate(434 1805)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 32,
    height: 32,
    transform: "translate(-434 -1805)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M107.526,100h4.568l-9.98,11.406,11.74,15.521h-9.192l-7.2-9.413-8.238,9.413H84.653l10.674-12.2L84.065,100H93.49L100,108.6Zm-1.6,24.193h2.531l-16.339-21.6H89.4Z",
    transform: "translate(-516.959 -1902.464)",
    fill: "#16ebc3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtwitter);
export default __webpack_public_path__ + "static/media/vtwitter.d6b14b7721305cb25d63bba023d35589.svg";
export { ForwardRef as ReactComponent };